import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FISCAL_YEAR_API } from "./apiRoutes";

const getTrialBalance = async (communityId: string | number, fiscalYear: string | number) => {
  return await axiosAuth.get(`${FISCAL_YEAR_API(communityId)}/${fiscalYear}/trial-balance`);
};

const useGetTrialBalance = ({
  communityId,
  fiscalYear,
  queryParams
}: 
{
  communityId?: string | number,
  fiscalYear?: string | number,
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}) =>
  useQuery({
    queryKey: ["trial-balance", communityId, fiscalYear],
    queryFn: () => getTrialBalance(communityId!, fiscalYear!),
    select: (data: any) => data.data,
    ...queryParams,
    enabled: !!communityId && !!fiscalYear && (queryParams?.enabled ?? true),
  });

export default useGetTrialBalance;